<template>
  <a-modal
    :visible="visible"
    :width="440"
    title="Exportar CSV"
    wrap-class-name="freight-table-export-modal"
    @cancel="$emit('close')"
  >
    <p class="freight-table-export-modal__question">
      Apenas vigências ativas?
    </p>

    <a-radio-group v-model="onlyActive">
      <a-radio :value="true">Sim</a-radio>
      <a-radio :value="false">Não</a-radio>
    </a-radio-group>

    <template slot="footer">
      <a-button :disabled="loading" @click="$emit('close')">Cancelar</a-button>
      <a-button type="primary" :loading="loading" @click="handleConfirm">
        Exportar
      </a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: "FreightTableExportModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      onlyActive: true,
    };
  },
  watch: {
    visible(isVisible) {
      if (isVisible) this.onlyActive = true;
    },
  },
  methods: {
    handleConfirm() {
      this.$emit("confirm", { onlyActive: this.onlyActive });
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/shared/styles/variables.less";

.freight-table-export-modal__question {
  font-size: 14px;
  color: @color-text-dark;
  margin: 0 0 16px 0;
}
</style>

<style lang="less">
@import "~@/shared/styles/variables.less";

.freight-table-export-modal {
  .ant-modal-title {
    font-size: 16px;
    font-weight: 600;
    color: @color-text-dark;
  }

  .ant-modal-body {
    padding: 24px;
  }

  .ant-radio-checked .ant-radio-inner {
    border-color: @color-primary;

    &::after {
      background-color: @color-primary;
    }
  }

  .ant-btn-primary {
    background-color: @color-primary;
    border-color: @color-primary;

    &:hover,
    &:focus {
      background-color: @color-primary-hover;
      border-color: @color-primary-hover;
    }
  }
}
</style>
